import { render, staticRenderFns } from "./updatenamelist.vue?vue&type=template&id=2eadfc9b"
import script from "./updatenamelist.vue?vue&type=script&lang=js"
export * from "./updatenamelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports